import React from 'react';
import { motion } from 'framer-motion';
interface PullQuoteProps {
  children: React.ReactNode;
}
export function PullQuote({
  children
}: PullQuoteProps) {
  return <motion.div initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="my-12 pl-8 border-l-4 border-[#2563EB]" data-id="element-120">
      <p className="text-xl md:text-2xl font-medium text-gray-900 leading-relaxed" data-id="element-121">
        {children}
      </p>
    </motion.div>;
}